<ng-content select="cs-fab"></ng-content>
<ng-template #projectedContent>
  <ng-content></ng-content>
</ng-template>
@if (noScroll) {
  <div class="no-scroll-content">
    <div class="header-scroll-padding" [ngStyle]="{'height.px': headerPaddingHeight}">
    </div>
    @if (showSpinner) {
      <div class="content-spinner">
        <cs-spinner></cs-spinner>
      </div>
    }
    @if (!loading) {
      <div class="content-wrapper" [class.animate-in]="animateContent">
        <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
      </div>
    }
    <div class="action-buttons-scroll-padding" [ngStyle]="{'height.px': actionButtonsPaddingHeight}">
    </div>
    <div class="bottom-nav-scroll-padding" [ngStyle]="{'height.px': bottomNavPaddingHeight}">
    </div>
  </div>
} @else {
  <cs-scrollable [scrollAreaClass]="'scroll-area scroll-content'" (scroll)="handleScroll($event)" #scrollable>
    @if (showSpinner) {
      <div class="content-spinner">
        <cs-spinner></cs-spinner>
      </div>
    }
    <div cdkScrollable>
      <div class="header-scroll-padding" [ngStyle]="{'height.px': headerPaddingHeight}">
      </div>
      @if (!loading) {
        <div class="content-wrapper" [class.animate-in]="animateContent">
          <ng-container *ngTemplateOutlet="projectedContent"></ng-container>
        </div>
      }
      <div class="action-buttons-scroll-padding" [ngStyle]="{'height.px': actionButtonsPaddingHeight}">
      </div>
      <div class="bottom-nav-scroll-padding" [ngStyle]="{'height.px': bottomNavPaddingHeight}">
      </div>
      <div class="keyboard-scroll-padding" [ngStyle]="{'height.px': keyboardPaddingHeight}">
      </div>
    </div>
  </cs-scrollable>
}